import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as orderActions from './../../../../../actions/orderAction';
import * as emailTemplateActions from './../../../../../actions/emailTemplateAction';
import { getRateCodeDetail } from './../../../../../actions/rateCodeAction';
import OrderDetail from './OrderDetail';
import { getVinwonderCustomersAction } from "../../../../../actions/orderAction";
import * as airportActions from './../../../../../actions/airportAction'

const mapStateToProps = state => {
    return {
        orderState: state.orderReducer,
        emailTemplateState: state.emailTemplateReducer,
        rateCodeState: state.rateCodeReducer,
        airportState: state.airportReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrderDetail: (id) => dispatch(orderActions.getOrderDetail(id)),
        setOrderDetail: (order) => dispatch(orderActions.setOrderDetail(order)),

        getOrderDetailGolf: (vptOrderId) => dispatch(orderActions.getOrderDetailGolf(vptOrderId)),
        setOrderDetailGolf: (orderGolf) => dispatch(orderActions.setOrderDetailGolf(orderGolf)),

        getAllEmailTemplates: () => dispatch(emailTemplateActions.getAllEmailTemplates()),
        getOrderItems: (orderId) => dispatch(orderActions.getOrderItemAction(orderId)),
        getOrderFlightItem: (productVariantId) => dispatch(orderActions.getOrderFlightItem(productVariantId)),
        getDetailVoucherOrder: (params) => dispatch(orderActions.getDetailVoucherOrderAction(params)),
        getOrderHotelBooking: (productVariantIds) => dispatch(orderActions.getOrderHotelBooking(productVariantIds)),
        getOrderHomestayBooking: (productVariantIds) => dispatch(orderActions.getOrderHomestayBooking(productVariantIds)),
        getOrderCrossSellBooking: (productVariantIds) => dispatch(orderActions.getOrderCrossSellBooking(productVariantIds)),
        onUpdateOrder: (order) => dispatch(orderActions.updateOrder(order)),
        onUpdateOrderAccountant: (order) => dispatch(orderActions.updateOrderAccountant(order)),
        onPushFixedCharge: (order) => dispatch(orderActions.pushFixCharge(order.id)),
        onUpdateFlight: (flight) => dispatch(orderActions.updateFlight(flight)),
        updateOrderInvoice: (orderInvoice) => dispatch(orderActions.updateOrderInvoice(orderInvoice)),
        sendEmailTemplate: (order, emailTemplate) => dispatch(orderActions.sendEmailTemplate(order, emailTemplate)),
        getItemSurchargeOrder: (params, listType) => dispatch(orderActions.getItemSurchargeOrder(params, listType)),
        deleteSurchargeDetail: (surcharge) => dispatch(orderActions.deleteSurchargeDetail(surcharge)),
        updateOrderItem: (orderItem, callback) => dispatch(orderActions.updateOrderItem(orderItem, callback)),
        lockOrderItem: (orderItem) => dispatch(orderActions.lockOrderItem(orderItem)),
        getRateCodeDetail: (id) => dispatch(getRateCodeDetail(id)),
        getVinwonderCustomers: (id) => dispatch(getVinwonderCustomersAction(id)),
        getSmsHistories: (id) => dispatch(orderActions.getSmsHistoriesAction(id)),
        resendSms: (id, orderId) => dispatch(orderActions.resendSmsAction(id, orderId)),
        onUpdateProfile: (profile,orderId) => dispatch(orderActions.updateProfile(profile,orderId)),
        resendFixCharge: (id) => dispatch(orderActions.resendFixChargeAction(id)),
        getListAirlineDomestic: () => dispatch(airportActions.getListAirlineDomestic()),
        getListAirportDeparture: () => dispatch(airportActions.getListAirportDeparture()),
        getListAirportArrival: () => dispatch(airportActions.getListAirportArrival()),
        getListFlightTrackingOrder: (orderId) => dispatch(orderActions.getListFlightTrackingOrder(orderId)),
        repushAffiliate: (orderId, status) => dispatch(orderActions.repushAffiliateAction(orderId, status)),
        getPointHistories: (id) => dispatch(orderActions.getPointHistoriesAction(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderDetail));
